'use strict'

/**
 * Public weight projections for master-lot manifest rows.
 *
 * This dependency-neutral leaf is shared by master-lot internals and
 * cross-cluster consumers such as contract-switch preview.
 */

import {extractDisplayWeight} from '@/util/refinery/weightUtils'
import {UNIT_KINDS} from '../constants'
import {toFinite} from './_shared'

/** Build a FE rich weight object from a troy-ounce scalar (fixtures / NS apply). */
export const richWeightFromTroyOunces = (troyOunces) => {
  if (troyOunces === null || troyOunces === undefined || troyOunces === '') return null
  const n = Number(troyOunces)
  if (!Number.isFinite(n)) return null
  return {troyOunces: n}
}

/**
 * Nullable source measured weight projection for display/export boundaries.
 */
export const sourceUnitWeightTroyOunces = (unit) => {
  const richWeight = extractDisplayWeight(unit?.weight, 'troyOunces')
  if (richWeight !== null) return richWeight
  return Number.isFinite(unit?.weightToz) ? unit.weightToz : null
}

/** Catalog per-item measured base weight (rich `unitWeight`) as troy ounces. */
export const catalogUnitWeightTroyOunces = (entry) => (
  extractDisplayWeight(entry?.unitWeight, 'troyOunces')
)

/**
 * Nullable manifest gross projection: source rows read rich `weight`; catalog
 * rows read scalar line-total `weightToz`.
 */
export const manifestUnitGrossTroyOunces = (unit) => {
  if (unit?.kind === UNIT_KINDS.CATALOG) {
    return Number.isFinite(unit?.weightToz) ? unit.weightToz : null
  }
  return sourceUnitWeightTroyOunces(unit)
}

/** Numeric manifest gross for arithmetic; missing contributes zero. */
export const manifestUnitGrossToz = (unit) => toFinite(manifestUnitGrossTroyOunces(unit))
